import api from './api';

const citiesService = {
  getAll: async () => {
    const response = await api.get('/city/get-city');
    return response.data.data || response.data;
  },

  getByState: async (stateId) => {
    const response = await api.get(`/city/get-city/${stateId}`);
    return response.data.data || response.data;
  },

  create: async (data) => {
    const response = await api.post('/city/add-city', data);
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/city/update-city/${id}`, data);
    return response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/city/delete-city/${id}`);
    return response.data;
  },
};

export default citiesService;
